<template>
    <div style="overflow: auto" class="row items-center">
        <div ref="text" class="col" style="margin-right: 15px; white-space: pre-line">
            <div v-html="html" />
        </div>
        <div v-show="params.accept_like === true" class="col-auto" style="padding-right: 10px">
            <ButtonLike :view="view" :page="page" />
        </div>
    </div>
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';
import ButtonLike from 'components/ui/extensions/ButtonLike';

export default {
    name: 'Text',
    components: { ButtonLike },
    mixins: [uiControlMixin],
    computed: {
        html () {
            return decodeURI(window.atob(this.params.html ?? ''));
        },
    },
};
</script>

<style scoped>

</style>
